export function stripHtml(html: string): string {
  let stripped = html.replace(/<[^>]*>/g, '');
  stripped = stripped.replace(/&[^;]+;/g, '');
  return stripped.trim();
}
